import { Play } from "lucide-react";

// "See Video" button — mirrors BidNowButton. Renders only when a video URL (YouTube) is set.
export const SeeVideoButton = ({ url, testid = "see-video-btn", className = "" }) => {
  if (!url) return null;
  return (
    <a
      href={url}
      target="_blank"
      rel="noreferrer noopener"
      data-testid={testid}
      className={`flex h-12 w-full items-center justify-center gap-2 rounded-full border-2 border-secondary font-bold text-secondary transition-transform hover:bg-secondary/10 active:scale-95 ${className}`}
    >
      <Play size={18} /> See Video
    </a>
  );
};
